import { SHOW_TEAM_AND_SITE_OWNER_HINT, HIDE_TEAM_AND_SITE_OWNER_HINT } from '../actions/action-types';

export const showTeamAndSiteOwnerHint = (state: boolean = null, action): boolean => {
    switch (action.type) {
        case SHOW_TEAM_AND_SITE_OWNER_HINT:
            return true;
        case HIDE_TEAM_AND_SITE_OWNER_HINT:
            return false;
        default:
            return state;
    }
};
